export default "__VITE_ASSET__7e00da28__"